"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftRowStats = void 0;
const offCountTypes_1 = __importDefault(require("./offCountTypes"));
class ShiftRowStats {
    laborHours = 0;
    numOfWorkers = 0;
    roleCounts = {};
    orRoleCounts = {};
    offCounts = {
        [offCountTypes_1.default.PTO]: 0,
        [offCountTypes_1.default.VACATION]: 0,
    };
    constructor() { }
    setOffCounts(v) {
        this.offCounts = v;
    }
    setRoleCounts(v) {
        this.roleCounts = v;
    }
    setOrRoleCounts(v) {
        this.orRoleCounts = v;
    }
    setLaborHours(v) {
        this.laborHours = v;
    }
    setNumOfWorkers(v) {
        this.numOfWorkers = v;
    }
}
exports.ShiftRowStats = ShiftRowStats;
